var map = {
	"./http.js": "6oO3",
	"./index.js": "9C8H",
	"./ticket.js": "4vd8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "20Xt";


//////////////////
// WEBPACK FOOTER
// ./src/http/modules \.js$
// module id = 20Xt
// module chunks = 1